// import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { emptySplitApi } from "./emptySplitApi";
import { API_END_POINTS } from "../config/ApiEndPoints";

export const api = emptySplitApi.injectEndpoints({
  reducerPath: "api",
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true,
  endpoints: (builder) => ({
    getDiplomaDate: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.diplomaDate+ '/' + params['branch'],
          method: "GET", 
        };
      }, 
    }),
    getDiplomaFindLocation: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.diplomaFindLocation + '/' + params,
          method: "GET",
          // params,
        };
      },
    }),
    getDiplomaFindSlot: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.diplomaFindSlot + '/' + params,
          method: "GET",
        };
      },
    }),
    diplomaSaveAppointment: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.diplomaSaveAppointment,
        method: "POST",
        body: data,
      }),
    }),
    ///////end diploma
     getAppointmentDate: builder.query({
      query: ({ params }) => {
        
        return {
          url: API_END_POINTS.appointmentDate+ '/' + params['branch'],
          method: "GET",
        };
      },
    }),
    getAppointmentFindLocation: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.appointmentFindLocation + '/' + params,
          method: "GET",
          // params,
        };
      },
    }),
    getAppointmentFindSlot: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.appointmentFindSlot + '/' + params,
          method: "GET",
        };
      },
    }),
    appointmentSaveAppointment: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.appointmentSaveAppointment,
        method: "POST",
        body: data,
      }),
    }),
    /////end appointment
    uploadFile: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.upload_file,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["uploadFile"]
    }),

    loginuser: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.login,
        method: "POST",
        body: { ...data },
      }),
    }),
    updatepassword: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.updatePassword,
        method: "PUT",
        body: { ...data },
      }),
    }),
    updateProfile: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.updateProfile,
        method: "PUT",
        body: { ...data },
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: API_END_POINTS.logout,
        method: "POST",
      }),
    }),
    adddiary: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.adddiary,
        method: "POST",
        body: { ...data },
      }),
    }),
    getdiarylist: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.diarylist,
          method: "GET",
          params,
        };
      },
    }),
    deletediary: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.deletediary,
        method: "DELETE",
        body: { ...data },
      }),
    }),
    getManagerList: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.managerList,
          method: "GET",
        };
      },
    }),
    ////////////////manager////////////
    getManager: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.manager,
          method: "GET",
          params,
        };

      },
      providesTags: ["getManager"]
    }),
    showManager: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.manager + '/' + params,
          method: "GET",
        };
      },
    }),
    addManager: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manager,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["getManager"]
    }),
    updateManager: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.manager + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getManager"]
    }),
    deleteManager: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manager,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getManager"]
    }),
    ////////////////leaner outcome////////////
    getLearningOutcome: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.learningOutcome,
          method: "GET",
          params,
        };
      },
      providesTags: ["getLearningOutcome"]
    }),
    showLearningOutcome: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.learningOutcome + '/' + params,
          method: "GET",
        };
      },
    }),
    getLearningOutcomeList: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.learningOutcomeList + '/' + params,
          method: "GET",
        };
      },
    }),
    addLearningOutcome: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.learningOutcome,
        method: "POST",
        body: data,

      }),
      invalidatesTags: ["getLearningOutcome"]
    }),
    updateLearningOutcome: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.learningOutcome + '/' + data.get('id'),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["getLearningOutcome"]
    }),
    deleteLearningOutcome: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.learningOutcome,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getLearningOutcome"]
    }),
    ////////////end learner outcome///////////////
    ////////////////leaner outcome detail////////////
    getLearningOutcomeDetail: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.learningOutcomeDetail,
          method: "GET",
          params,
        };
      },
      providesTags: ["getLearningOutcomeDetail"]
    }),
    showLearningOutcomeDetail: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.learningOutcomeDetailSingle + '/' + params,
          method: "GET",
        };
      },
    }),

    addLearningOutcomeDetail: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.learningOutcomeDetailAdd,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["getLearningOutcomeDetail"]
    }),
    updateLearningOutcomeDetail: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.learningOutcomeDetail + '/' + data.get('id'),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["getLearningOutcomeDetail"]
    }),
    deleteLearningOutcomeDetail: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.learningOutcomeDetail,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getLearningOutcomeDetail"]
    }),
    //////////article //////////
    showArticle: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.Article + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["getArticle"]
    }),
    showSingleArticle: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.showArticle + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["getArticle"]
    }),
    addArticle: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.Article,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["getArticle"]
    }),
    updateArticle: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.Article + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getArticle"]
    }),
    deleteArticle: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.Article,
          method: "DELETE",
          body: { ...data },
        };
      },
      invalidatesTags: ["getArticle"]
    }),
    //////////////case study///////////
    showCaseStudy: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.CaseStudy + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["getCaseStudy"]
    }),
    showSingleCaseStudy: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.showCaseStudy + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["getCaseStudy"]
    }),
    addCaseStudy: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.CaseStudy,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["getCaseStudy"]
    }),
    updateCaseStudy: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.CaseStudy + '/' + data.get('id'),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["getCaseStudy"]
    }),
    deleteCaseStudy: builder.mutation({
      query: ({ data }) => {
        return {
          url: API_END_POINTS.CaseStudy,
          method: "DELETE",
          body: { ...data },
        };
      },
      invalidatesTags: ["getCaseStudy"]
    }),
    //////////////////video/////////
    showVideo: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.Video + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["getVideo"]

    }),
    playVideo: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.VideoPlay + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["getVideo"]

    }),
    addVideo: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.Video,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["getVideo"]
    }),
    deleteVideo: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.Video,
        method: "Delete",
        body: { ...data },
      }),
      invalidatesTags: ["getVideo"]
    }),


    ////////////end learner outcome detail///////////////
    getStudentList: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.studentList,
          method: "GET",
        };
      },
    }),
    getMainCourse: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.mainCourse,
          method: "GET",
        };
      },
    }),
    getLicenseExpiryList: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.licenseExpiryList,
          method: "GET",
        };
      },
    }),
    getCourseList: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.courseList + '/' + params,
          method: "GET",
        };
      },
    }),
    ////////////////student////////////
    getStudent: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.student,
          method: "GET",
          params,
        };

      },
      providesTags: ["getStudent"]
    }),
    showStudent: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.student + '/' + params,
          method: "GET",
        };
      },
    }),
    addStudent: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.student,
        method: "POST",
        body: { ...data },

      }),
      invalidatesTags: ["getStudent"]
    }),
    updateStudent: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.student + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getStudent"]
    }),
    deleteStudent: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.student,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getStudent"]
    }),

    ////////////////enroll student////////////
    getEnrollment: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.enrollStudent,
          method: "GET",
          params,
        };

      },
      providesTags: ["getEnrollment"]
    }),
    getEnrollmentList: builder.query({
      query: ({ pageUrl, params }) => {
     
        return {
          url: pageUrl || API_END_POINTS.enrollStudent+'/'+params['course_id']+'/'+params['element'],
          method: "GET",
          params,
        };

      },
      providesTags: ["getEnrollment"]
    }),
    showEnrollment: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.enrollStudent + '/' + params,
          method: "GET",

        };
      },
    }),
    addEnrollment: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.enrollStudent,
        method: "POST",
        body: { ...data },

      }),
      invalidatesTags: ["getEnrollment"]
    }),
    updateEnrollment: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.enrollStudent + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getEnrollment"]
    }),
    deleteEnrollment: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.enrollStudent,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getEnrollment"]
    }),
    ////////////////enroll review////////////
    getReviewEnrollment: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.enrollmentReview,
          method: "GET",
          params,
        };
      },
      providesTags: ["getEnrollmentReview"]
    }),
    showReviewEnrollment: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.enrollmentReview + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["getEnrollmentReview"]
    }),
    updateReviewEnrollment: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.enrollmentReview + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getEnrollment"]
    }),
    deleteEnrollmentReview: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.enrollmentReview,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getEnrollmentReview"]
    }),

    ////////////////dasboard/////////////
    getAdminDashboard: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.adminDashboard,
          method: "GET",
          params,
        };
      },
      providesTags: ["getAdminDashboard"]
    }),
    ////////////////enrollmentStatistics/////////////
    getEnrollmentStatistics: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.enrollmentStatistics,
          method: "GET",
          params,
        };
      },
      providesTags: ["getEnrollmentStatistics"]
    }),
    ////////////////learner progress/////////////
    getLearnerProgress: builder.query({

      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.learnerProgress,
          method: "GET",
          params,
        };
      },
      providesTags: ["getLearnerProgress"]
    }),
    getLoadUnit: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.loadUnit + '/' + params,
          method: "GET",
        };
      },
    }),
    /////////////resource////////////////////
    getResource: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.resource,
          method: "GET",
          params,
        };

      },
      providesTags: ["getResource"]
    }),
    addResource: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.resource,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["getResource"]
    }),
    showResource: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.resource + '/' + params,
          method: "GET",

        };
      },
      invalidatesTags: ["getResource"]
    }),
    updateResource: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.resource + '/' + data.get('id'),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["getResource"]
    }),
    deleteResource: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.resource,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getResource"]
    }),
    ////////////end /////////////////
    /////////////qualification////////////////////
    getQualification: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.qualification,
          method: "GET",
          params,
        };
      },
      providesTags: ["getQualification"]
    }),
    addQualification: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.qualification,
        method: "POST",
        body: { ...data },

      }),
      invalidatesTags: ["getQualification"]
    }),
    showQualification: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.qualification + '/' + params,
          method: "GET",

        };
      },
      invalidatesTags: ["getQualification"]
    }),
    updateQualification: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.qualification + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getQualification"]
    }),
    deleteQualification: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.qualification,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getQualification"]
    }),
    getQualificationList: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.qualificationList,
          method: "GET",
        };
      },
    }),
    ////////////end /////////////////
    /////////////course////////////////////
    getCourse: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.course,
          method: "GET",
          params,
        };
      },
      providesTags: ["getCourse"]
    }),
    addCourse: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.course,
        method: "POST",
        body: data,

      }),
      invalidatesTags: ["getCourse"]
    }),
    showCourse: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.course + '/' + params,
          method: "GET",

        };
      },
      invalidatesTags: ["getCourse"]
    }),
    updateCourse: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.course + '/' + data.get('id'),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["getCourse"]
    }),
    deleteCourse: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.course,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getCourse"]
    }),
    ////////////end /////////////////
    /////////////ManageModule////////////////////
    getManageModule: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.manageModule,
          method: "GET",
          params,
        };
      },
      providesTags: ["getManageModule"]
    }),
    addManageModule: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manageModule,
        method: "POST",
        body: { ...data },

      }),
      invalidatesTags: ["getManageModule"]
    }),
    showManageModule: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.manageModule + '/' + params,
          method: "GET",

        };
      },
      invalidatesTags: ["getManageModule"]
    }),
    updateManageModule: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.manageModule + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getManageModule"]
    }),
    deleteManageModule: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manageModule,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getManageModule"]
    }),
    ////////////end /////////////////
    /////////////Manage Sub Module////////////////////
    getManageSubModule: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.manageSubModule,
          method: "GET",
          params,
        };
      },
      providesTags: ["getManageSubModule"]
    }),
    addManageSubModule: builder.mutation({
      query: (formData) => ({
        url: API_END_POINTS.manageSubModule,
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["getManageSubModule"]
    }),
    showManageSubModule: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.manageSubModule + '/' + params,
          method: "GET",

        };
      },
      invalidatesTags: ["getManageSubModule"]
    }),
    updateManageSubModule: builder.mutation({
      query: (data) => {
        return {
          url: API_END_POINTS.manageSubModule + '/' + data.get('id'),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["getManageSubModule"]
    }),
    deleteManageSubModule: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manageSubModule,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getManageSubModule"]
    }),
    ////////////end /////////////////
    /////////////Question////////////////////
    getQuestion: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.manageQuestion,
          method: "GET",
          params,
        };
      },
      providesTags: ["getQuestion"]
    }),
    addQuestion: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manageQuestion,
        method: "POST",
        body: { ...data },

      }),
      invalidatesTags: ["getQuestion"]
    }),
    showQuestion: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.manageQuestion + '/' + params,
          method: "GET",

        };
      },
      invalidatesTags: ["getQuestion"]
    }),
    updateQuestion: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.manageQuestion + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getQuestion"]
    }),
    deleteQuestion: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manageQuestion,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getQuestion"]
    }),
    ////////////end /////////////////
    /////////////Question option////////////////////
    getQuestionOption: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.multipleOption,
          method: "GET",
          params,
        };
      },
      providesTags: ["getQuestionOption"]
    }),
    addQuestionOption: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.multipleOption,
        method: "POST",
        body: { ...data },

      }),
      invalidatesTags: ["getQuestionOption"]
    }),
    showQuestionOption: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.multipleOption + '/' + params,
          method: "GET",

        };
      },
      invalidatesTags: ["getQuestionOption"]
    }),
    updateQuestionOption: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.multipleOption + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getQuestionOption"]
    }),
    deleteQuestionOption: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.multipleOption,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getQuestionOption"]
    }),
    ////////////end /////////////////
    /////////////Question option////////////////////
    getCertificateList: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.certificateList,
          method: "GET",
          params,
        };
      },
      providesTags: ["getCertificateList"]
    }),
    /////////////Question option////////////////////
    getManageExam: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.manageExam,
          method: "GET",
          params,
        };
      },
      providesTags: ["getManageExam"]
    }),
    updateManageExam: builder.mutation({
      query: ({ data, param }) => {
        return {
          url: API_END_POINTS.manageExam + '/' + param,
          method: "PUT",
          body: { ...data },
        };
      },
      invalidatesTags: ["getManageExam"]
    }),
    deleteManageExam: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.manageExam,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getManageExam"]
    }),
    ///////////message/////////////
    sendMessage: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.sendMessage,
        method: "POST",
        body: { ...data },

      }),
      invalidatesTags: ["getMessage"]
    }),
    ////////////end /////////////////
    // student side api start
    studentLoginUser: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.studentLogin,
        method: "POST",
        body: { ...data },
      }),
    }),
    studentSignUp: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.studentSignUp,
        method: "POST",
        body: { ...data },
      }),
    }),
    studentUpdatePassword: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.studentUpdatePass,
        method: "PUT",
        body: { ...data },
      }),
    }),
    studentUpdateProfile: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.studentUpdateProfile,
        method: "POST",
        body: { ...data },
      }),
    }),
    sendForgetPassLink: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.sendForgetPassLink,
        method: "POST",
        body: { ...data },
      }),
    }),
    getStudentResource: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.studentResource,
          method: "GET",
          params,
        };
      },
      providesTags: ["getStudentResource"]
    }),
    getStudentMyProgress: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.studentProgress,
          method: "GET",
          params,
        };
      },
      providesTags: ["getStudentMyProgress"]
    }),
    ////////My Courses/training///////////
    getStudentMyCourse: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.studentMyCourse,
          method: "GET",
          params,
        };
      },
      providesTags: ["getStudentMyCourse"]
    }),
    getStudentCourseTopic: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.studentCourseTopic,
          method: "GET",
          params,
        };
      },
      providesTags: ["getStudentCourseTopic"]
    }),
    getStudentCourseTopicDetail: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.studentCourseTopicDetail,
          method: "GET",
          params,
        };
      },
      providesTags: ["getStudentCourseTopic"]
    }),
    getstudentFreeCourseTopic: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.studentFreeCourseTopic,
          method: "GET",
          params,
        };
      },
      providesTags: ["getstudentFreeCourseTopic"]
    }),
    getstudentFreeCourseTopicDetail: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.studentFreeCourseTopicDetail,
          method: "GET",
          params,
        };
      },
      providesTags: ["getstudentFreeCourseTopicDetail"]
    }),
    getstudentMultipleQuestionList: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.studentMultipleQuestionList,
          method: "GET",
          params,
        };
      },
      providesTags: ["getstudentFreeCourseTopicDetail"]
    }),
    getFreeCourseDetailPdf: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.studentFreeCourseDetailPdf,
          method: "GET",
          params,
        };
      },
      providesTags: ["getFreeCourseDetailPdf"]
    }),
    getstudentquestionPdf: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.studentquestionPdf,
          method: "GET",
          params,
        };
      },
      providesTags: ["getstudentquestionPdf"]
    }),
    getStudentCourseOutcome: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.studentCourseOutcome,
          method: "GET",
          params,
        };
      },
      providesTags: ["getStudentCourseTopic"]
    }),
    getStudentCourseOutcomePdf: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.studentCourseOutcomePdf,
          method: "GET",
          params,
        };
      },
      providesTags: ["getStudentCourseTopic"]
    }),
    getStudentFinalQuizStart: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.studentFinalQuizStart + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["studentFinalQuizStart"]
    }),
    studentExamCount: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.studentExamCount + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["studentFinalQuizStart"]
    }),
    longQuestionsList: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.longQuestionsList + '/' + params,
          method: "GET",
        };
      },
      providesTags: ["longQuestionsList"]
    }),
    longQuestionsResult: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: API_END_POINTS.longQuestionsResult,
          method: "GET",
          params,
        };
      },
      providesTags: ["longQuestionsResult"]
    }),
    addUploadMocExamResult: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.uploadMocExamResult,
        method: "POST",
        body: data
      }),
      providesTags: ["longQuestionsResult"]
    }),
    saveStudentTime: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.saveStudentTime,
        method: "POST",
        body: { ...data },
      }),
    }),
    studentSubmitQuiz: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.studentSubmitQuiz,
        method: "POST",
        body: { ...data },
      }),
    }),
    studentFinalQuizSubmit: builder.mutation({
      query: ({ data }) => {
        return {
          url: API_END_POINTS.studentFinalQuizSubmit,
          method: "POST",
          body: data,
        };
      },
    }),
    submitLongQuestions: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.submitLongQuestions,
        method: "POST",
        body: { ...data },
      }),
    }),
    resultDetail: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.resultDetail + '/' + params,
          method: "GET",
        };
      },
    }),
    submitMockExamMarks: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.submitMockExamMarks,
        method: "POST",
        body: { ...data },
      }),
    }),
   
    getStudentExamResult: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.studentExamResult,
          method: "GET",
        };
      },
    }),
    getParticipants: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.courseParticipants + '/' + params.param,
          method: "GET",
          params,
        };

      },
      providesTags: ["getParticipants"]
    }),
    getCourseCountryWise: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.courseCountryWise + '/' + params,
          method: "GET",
        };

      },
      providesTags: ["getCourseCountryWise"]
    }),
    getTeacherQuestion: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.teacherQuestions + '/' + params,
          method: "GET",
          params,
        };

      },
      providesTags: ["getTeacherQuestion"]
    }), 
    addReply: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addReply,
        method: "POST",
        body: { ...data }, 
      }),
      invalidatesTags: ["getTeacherQuestion"]
    }),

    //////////end My Courses/training////////
    // student side api ended
    getAdminParticipants: builder.query({
      query: ({ pageUrl, params }) => {

        return {
          url: pageUrl || API_END_POINTS.adminParticipants,
          method: "GET",
          params,
        };
      },
      providesTags: ["getAdminParticipants"]
    }),
    getTask: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.task,
          method: "GET",
          params,
        };
      },
      providesTags: ["getTask"]
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.task,
        method: "POST",
        body: data,

      }),
      invalidatesTags: ["getTask"]
    }),
    addTaskDetails: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.taskDetails,
        method: "POST",
        body: data,

      }),
      invalidatesTags: ["getTask"]
    }),
    ////
    getAdminTeacherQuestion: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.teacherQuestion,
          method: "GET",
          params,
        };
      },
      providesTags: ["getTeacherQuestion"]
    }),

    addTeacherQuestion: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.teacherQuestion,
        method: "POST",
        body: data,

      }),
      invalidatesTags: ["getTeacherQuestion"]
    }),

     getAdminGroup: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.courseGroup,
          method: "GET",
          params,
        };
      },
      providesTags: ["getAdminGroup"]
    }),
   getAdminGroupList: builder.query({
      query: ({ pageUrl, params }) => {
        return {
          url: pageUrl || API_END_POINTS.groupListDetails,
          method: "GET",
          params,
        };
      },
      providesTags: ["getAdminGroup"]
    }),
    addAdminGroup: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.courseGroup,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["getAdminGroup"]
    }),
   
    deleteBatch: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.deleteBatch,
        method: "DELETE",
        body: { ...data },
      }),
      invalidatesTags: ["getAdminParticipants"]
    }),
    addAsignBatch: builder.mutation({
      query: ( data ) => {
        return { 
          url: API_END_POINTS.asignBatch,
          method: "POST",
          body: { ...data },
        };
      },
      invalidatesTags: ["getAdminParticipants"]
    }),
    //////////////end api///////////////////
    
  }),
  overrideExisting: true,
});
export const {
  useDeleteBatchMutation,
  useAddAsignBatchMutation,
  useAddAdminGroupMutation,
  useGetAdminGroupQuery,
  useGetAdminGroupListQuery,
  useAddTeacherQuestionMutation,
  useAddTaskDetailsMutation,
  useAddTaskMutation,
  useGetTaskQuery,
  useGetAdminParticipantsQuery,
  useAddReplyMutation,
  useGetTeacherQuestionQuery,
  useGetAdminTeacherQuestionQuery,
  useGetCourseTaskQuery,
  useGetParticipantsQuery,
  useGetCourseCountryWiseQuery,
  useGetDiplomaFindSlotQuery,
  useGetDiplomaFindLocationQuery,
  useGetDiplomaDateQuery,
  useDiplomaSaveAppointmentMutation,
  //////end diploma //////////////
  useGetAppointmentDateQuery,
  useGetAppointmentFindSlotQuery,
  useGetAppointmentFindLocationQuery,
  useAppointmentSaveAppointmentMutation,
  ////////end appointment/////////
  useUploadFileMutation,
  useLoginuserMutation,
  useUpdatepasswordMutation,
  useUpdateProfileMutation,
  useLogoutMutation,
  ///////////diary list////
  useAdddiaryMutation,
  usedeletediaryMutation,
  useGetdiarylistQuery,
  /////////manager list/////////
  useGetManagerListQuery,
  useGetManagerQuery,
  useShowManagerQuery,
  useAddManagerMutation,
  useUpdateManagerMutation,
  useDeleteManagerMutation,
  /////////learning Outcome list/////////
  useGetLearningOutcomeListQuery,
  useGetLearningOutcomeQuery,
  useShowLearningOutcomeQuery,
  useAddLearningOutcomeMutation,
  useUpdateLearningOutcomeMutation,
  useDeleteLearningOutcomeMutation,
  /////////learning Outcome detail list/////////
  useGetLearningOutcomeDetailListQuery,
  useGetLearningOutcomeDetailQuery,
  useShowLearningOutcomeDetailQuery,
  useAddLearningOutcomeDetailMutation,
  useUpdateLearningOutcomeDetailMutation,
  useDeleteLearningOutcomeDetailMutation,
  //////////article
  useShowArticleQuery,
  useShowSingleArticleQuery,
  useAddArticleMutation,
  useUpdateArticleMutation,
  useDeleteArticleMutation,
  /////////video///////
  useShowVideoQuery,
  usePlayVideoQuery,
  useAddVideoMutation,
  useDeleteVideoMutation,
  ///////case study/////////
  useShowCaseStudyQuery,
  useShowSingleCaseStudyQuery,
  useAddCaseStudyMutation,
  useUpdateCaseStudyMutation,
  useDeleteCaseStudyMutation,
  /////////student list/////////
  useGetStudentListQuery,
  useGetStudentQuery,
  useShowStudentQuery,
  useAddStudentMutation,
  useUpdateStudentMutation,
  useDeleteStudentMutation,
  /////////student list/////////
  useGetEnrollmentQuery,
  useGetEnrollmentListQuery,
  useGetMainCourseQuery,
  useGetLicenseExpiryListQuery,

  useShowEnrollmentQuery,
  useAddEnrollmentMutation,
  useUpdateEnrollmentMutation,
  useDeleteEnrollmentMutation,
  /////////review enroll list/////////
  useGetReviewEnrollmentQuery,
  useShowReviewEnrollmentQuery,
  useUpdateReviewEnrollmentMutation,
  useDeleteEnrollmentReviewMutation,
  useGetEnrollmentStatisticsQuery,
  /////////learner list/////////
  useGetLearnerProgressQuery,
  useGetLoadUnitQuery,
  /////////resource list/////////
  useGetResourceQuery,
  useShowResourceQuery,
  useAddResourceMutation,
  useUpdateResourceMutation,
  useDeleteResourceMutation,
  /////////resource list/////////
  useGetQualificationQuery,
  useGetQualificationListQuery,
  useShowQualificationQuery,
  useAddQualificationMutation,
  useUpdateQualificationMutation,
  useDeleteQualificationMutation,
  /////////course list/////////
  useGetCourseQuery,
  useGetCourseListQuery,
  useShowCourseQuery,
  useAddCourseMutation,
  useUpdateCourseMutation,
  useDeleteCourseMutation,
  /////////manageModule list/////////
  useGetManageModuleQuery,
  useGetManageModuleListQuery,
  useShowManageModuleQuery,
  useAddManageModuleMutation,
  useUpdateManageModuleMutation,
  useDeleteManageModuleMutation,
  /////////manage sub Module list/////////
  useGetManageSubModuleQuery,
  useGetManageSubModuleListQuery,
  useShowManageSubModuleQuery,
  useAddManageSubModuleMutation,
  useUpdateManageSubModuleMutation,
  useDeleteManageSubModuleMutation,
  /////////manage question list/////////
  useGetQuestionQuery,
  useGetQuestionListQuery,
  useShowQuestionQuery,
  useAddQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  /////////manage question option list/////////
  useGetQuestionOptionQuery,
  useGetQuestionOptionListQuery,
  useShowQuestionOptionQuery,
  useAddQuestionOptionMutation,
  useUpdateQuestionOptionMutation,
  useDeleteQuestionOptionMutation,
  /////////certificate list/////////
  useGetCertificateListQuery,
  /////////manage exam list/////////
  useGetManageExamQuery,
  useShowManageExamQuery,
  useAddManageExamMutation,
  useUpdateManageExamMutation,
  useDeleteManageExamMutation,
  //////////messages////////////
  useSendMessageMutation,
  ////////////dashboard///////////////
  useGetAdminDashboardQuery,
  //student side 
  useStudentLoginUserMutation,
  useStudentUpdatePasswordMutation,
  useStudentUpdateProfileMutation,
  useSendForgetPassLinkMutation,
  useStudentSignUpMutation,
  ////////////////
  useGetStudentMyCourseQuery,
  useGetStudentCourseTopicQuery,
  useGetstudentFreeCourseTopicQuery,
  useGetstudentFreeCourseTopicDetailQuery,
  ///////////
  useGetStudentResourceQuery,
  useGetStudentMyProgressQuery,

  useGetstudentMultipleQuestionListQuery,
  useLongQuestionsResultQuery,
  useStudentSubmitQuizMutation,
  useSubmitLongQuestionsMutation,
  useResultDetailQuery,

  useStudentExamCountQuery,
  useLongQuestionsListQuery,
  useStudentFinalQuizSubmitMutation,
  useGetFreeCourseDetailPdfQuery,
  useGetstudentquestionPdfQuery,
  ///////////////
  useGetStudentCourseTopicDetailQuery,
  useGetStudentCourseOutcomeQuery,
  useGetStudentCourseOutcomePdfQuery,
  useGetStudentFinalQuizStartQuery,
  useSaveStudentTimeMutation,
  ///////////
  useSubmitMockExamMarksMutation,
  submitMockExamMarks,
  useAddUploadMocExamResultMutation,
  useGetStudentExamResultQuery,
  // end student side  //////////
} = api;